<template>
	<div class="my-rewards">
		<div class="default-block-title">
			{{ t.myRewardsBlockTitle }}
		</div>

		<transition name="fade" mode="out-in">
			<div v-if="!loaded" class="spinner" style="position: inherit;">
				<loader />
			</div>
			
			<div v-else-if="items.length">
				<router-link v-for="item in items" :key="item.id" v-slot="{ navigate }" :to="{name: 'prizes-reward', params: { rewardId: item.id }}" custom>
					<div class="item" @click="navigate">
						<div class="image" :style="{backgroundImage: `url(${item.imageUrl})`}" />
						<div class="name" :title="getTranslation(item.name)">
							{{ getTranslation(item.name) }}
						</div>
						<div class="code">
							<font-awesome-icon v-if="(item.code_media=='barcode' || item.code_media=='code_barcode') && item.barcode_type!='QRCODE'" icon="barcode" />
							<font-awesome-icon v-if="(item.code_media=='barcode' || item.code_media=='code_barcode' || item.code_media=='loungekey') && item.barcode_type=='QRCODE'" icon="qrcode" />

							<span v-if="item.code_media=='code' || item.code_media=='code_barcode'" class="ml-1">
								{{ item.reward_code }}
							</span>
						</div>
						<div class="expires">
							{{ expiresText(item) }}
						</div>
						<div class="clearfix" />
					</div>
				</router-link>
			</div>
			
			<div v-else>
				<div class="block-no-items">
					{{ t.myRewardsBlockNoItems }}
				</div>
			</div>
		</transition>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import dayjs from "@/js/includes/dayjs";
import { getTranslation } from "../../includes/helpers"
import { humanize, insertText } from '../../includes/helpers'
import { useStore } from '@/js/stores/index';

const store = useStore()

// Computeds
const t = computed(() => store.translations)
const items = computed((): any[] => store.rewards || [])
const loaded = computed(() => store.rewards !== null)

function expiresText(item: {
	valid_till: string,
	creation_date: string,
})
{
	return insertText(t.value.myRewardsBlockExpiresOn,
		humanize(item.valid_till), 
		dayjs(item.creation_date).format('LL'))
}
</script>
